import { warn } from "@swivl-mono/helpers";
import { ReviewInterface } from "@swivl-mono/types";
import { Button } from "@swivl-mono/ui";
import { useEffect, useState } from "react";
import ModalModel from "../../../../Models/Modal/Modal.Model";
import ReviewsModel from "../../../../Models/Reviews/Reviews.Model";
import "./Reviews.View.MultiSelect.Modal.scss";

interface Props {
  reviews: { [id: number]: ReviewInterface }
  replyText: string
}

export function ReviewsViewMultiSelectModal(props: Props) {
  const { reviews, replyText } = props;
  const [reviewsToUpdate] = useState<ReviewInterface[]>(Object.values(props.reviews))
  const [index, setIndex] = useState(-1);
  const [cancelled, setCanceled] = useState(false);
  const [failedRequests, setFailedRequests] = useState(0);

  useEffect(() => {
    if (index < 0) {
      return;
    }
    // declare the data fetching function
    const fetchData = async () => {
      if (cancelled) {
        console.warn("Canceling")
        return;
      }
      if (index >= reviewsToUpdate.length) {
        return;
      }

      const element = reviewsToUpdate[index];
      await ReviewsModel.replyToReview(element, replyText);
    }

    fetchData().catch(e => {
      warn("Failed to update review", e);
      setFailedRequests(failedRequests + 1);
    }).finally(() => {
      setIndex(index + 1);
    })
  }, [index])

  useEffect(() => {
    setIndex(0)
  }, [])

  let icon = "⏳"
  let title = "Publishing Replies"
  let message = `Please wait while we publish ${index + 1} of ${reviewsToUpdate.length} replies...`
  let errors = failedRequests > 0 ? <div className="errors">{failedRequests} replies failed to publish.</div > : null;
  let button = <Button onClick={() => { setCanceled(true) }}>Cancel</Button>

  if (cancelled) {
    icon = "⚠️"
    title = "Publishing Canceled"
    message = `Published ${index - failedRequests} of ${reviewsToUpdate.length} replies.`
    button = <Button onClick={() => { ModalModel.hideModal() }}>Close</Button>
  } else if (index >= reviewsToUpdate.length) {
    icon = "✅"
    title = "Publishing Complete"
    message = `Published ${reviewsToUpdate.length - failedRequests} of ${reviewsToUpdate.length} replies.`
    button = <Button onClick={() => { ModalModel.hideModal() }}>Close</Button>
  }

  return <div className="ReviewsViewMultiSelectModal">
    <div className="icon">{icon}</div>
    <div className="heading">{title}</div>
    <div className="message">{message}</div>
    {errors}
    {button}
  </div>

}